"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var utils_1 = require("./utils");
var globals_1 = require("./globals");
var ua_parser_js_1 = require("ua-parser-js");
var AppLaunched = /** @class */ (function (_super) {
    __extends(AppLaunched, _super);
    function AppLaunched() {
        var _this = this;
        var body = {
            device: "",
            user_agent: "",
            connection: "",
            id_type: globals_1.default.id_type,
            id_value: null,
            lang: "",
            os_version: "",
            is_refreshed: 0,
            query_string_params: {},
            screen: {}
        };
        if (utils_1.default.isClient()) {
            var userAgent = new ua_parser_js_1.UAParser();
            var device = (userAgent.getDevice().vendor || userAgent.getDevice().model) ? userAgent.getDevice().vendor + " " + userAgent.getDevice().model : userAgent.getCPU().architecture ? 'pc' : 'unknown';
            var cookie = void 0;
            if (!(cookie = utils_1.default.getCookie(utils_1.default.COOKIE_ID_KEY))) {
                utils_1.default.setCookie(utils_1.default.COOKIE_ID_KEY, (cookie = utils_1.default.uuidv4()), 0);
            }
            var screen_1 = window.screen ? {
                height: window.screen.height,
                width: window.screen.width
            } : {};
            body = {
                device: device,
                user_agent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                connection: "",
                id_type: globals_1.default.id_type,
                id_value: cookie,
                lang: navigator === null || navigator === void 0 ? void 0 : navigator.language,
                os_version: navigator === null || navigator === void 0 ? void 0 : navigator.platform,
                is_refreshed: 0,
                query_string_params: {},
                screen: screen_1
            };
        }
        _this = _super.call(this, "appLaunched", body) || this;
        _this.setQueryStringParams();
        return _this;
    }
    AppLaunched.prototype.GetDevice = function () {
        return this.getEventBody().getJson().device;
    };
    ;
    AppLaunched.prototype.GetUserAgent = function () {
        return this.getEventBody().getJson().user_agent;
    };
    ;
    AppLaunched.prototype.GetConnection = function () {
        return this.getEventBody().getJson().connection;
    };
    ;
    AppLaunched.prototype.SetConnection = function (connection) {
        this.getEventBody().getJson().connection = connection;
        return this;
    };
    ;
    AppLaunched.prototype.GetIdType = function () {
        return this.getEventBody().getJson().id_type;
    };
    ;
    AppLaunched.prototype.setQueryStringParams = function () {
        if (utils_1.default.isClient()) {
            this.getEventBody().getJson().query_string_params = utils_1.default.getQueryStringParams(window.location.search);
        }
        return this;
    };
    AppLaunched.prototype.GetIdValue = function () {
        return this.getEventBody().getJson().id_value;
    };
    ;
    AppLaunched.prototype.GetLang = function () {
        return this.getEventBody().getJson().lang;
    };
    ;
    AppLaunched.prototype.GetOsVersion = function () {
        return this.getEventBody().getJson().os_version;
    };
    ;
    AppLaunched.prototype.SetIsRefreshed = function (is_refreshed) {
        this.getEventBody().getJson().is_refreshed = is_refreshed;
        return this;
    };
    ;
    AppLaunched.prototype.GetIsRefreshed = function () {
        return this.getEventBody().getJson().is_refreshed;
    };
    AppLaunched.prototype._isPrefab = function () {
        return true;
    };
    return AppLaunched;
}(event_1.default));
exports.default = AppLaunched;
//# sourceMappingURL=appLaunched.js.map